
export default function Navigation() {
  return (
    <section id="about" className="py-20 lg:py-32 px-6 lg:px-12 bg-white">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl lg:text-5xl text-[#042A60] mb-8 font-light">
          Warum KI für viele noch nicht optimal funktioniert
        </h2>
        <p className="text-base text-[#042A60]/80 leading-relaxed">
          Du weißt, dass KI wichtig ist. Aber zwischen dem Wissen und dem Handeln liegt eine Kluft, die größer ist als jedes Tool überbrücken kann. Die meisten Unternehmen sammeln Software-Lizenzen wie andere Menschen Briefmarken – und am Ende sitzt du vor einem Chaos aus Möglichkeiten, ohne zu wissen, welche davon dir wirklich helfen. Die Hersteller versprechen Wunder, die Berater sprechen in Algorithmen, und du fragst dich nur, wie das alles in deinen Arbeitsalltag passt. Das Problem ist nicht die Technologie. Das Problem ist die fehlende Übersetzung. KI bleibt abstrakt, solange sie nicht konkrete Rollen bekommt – Menschen, die du verstehst, die für dich arbeiten, deren Erfolg du messen kannst. klar:ki übersetzt KI in verständliche Assistent:innen mit klaren Business-Zielen und ROI-Fokus statt Hype.
        </p>
      </div>
    </section>
  );
}
